'use client';

import React from 'react';

import type { StatsIntervalIds } from 'types/client/stats';

import { STATS_INTERVALS } from 'src/components/stats/constants';

import styles from './ChartIntervalSelect.module.css';

type Props = {
  interval: StatsIntervalIds;
  onIntervalChange: (newInterval: StatsIntervalIds) => void;
  isLoading?: boolean;
  selectTagSize?: string;
};

const intervalIds = Object.keys(STATS_INTERVALS) as Array<StatsIntervalIds>;

const ChartIntervalSelect = ({ interval, onIntervalChange, isLoading }: Props) => {
  return (
    <>
      <div className={ styles.buttonGroup }>
        { intervalIds.map((id) => (
          <button
            key={ id }
            className={ `${ styles.button } ${ interval === id ? styles.buttonActive : '' }` }
            onClick={ () => onIntervalChange(id) }
            disabled={ isLoading }
          >
            { STATS_INTERVALS[id].shortTitle }
          </button>
        )) }
      </div>
      <select
        className={ styles.select }
        value={ interval }
        onChange={ (e) => onIntervalChange(e.target.value as StatsIntervalIds) }
        disabled={ isLoading }
      >
        { intervalIds.map((id) => (
          <option key={ id } value={ id }>
            { STATS_INTERVALS[id].title }
          </option>
        )) }
      </select>
    </>
  );
};

export default React.memo(ChartIntervalSelect);
